import { MapPinIcon as LocationMarkerIcon, VideoCameraIcon } from '@heroicons/react/24/solid';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { AddToCalender } from '../../../../Components/AddToCalender';
import { FuneralService, FuneralServiceEvent } from '../../../../types';

const Event = ({ event, service, timezone }: { event: FuneralServiceEvent; service: FuneralService; timezone: string }) => {
  const { address } = event.venue;
  const link = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <div className="event-container">
      <div className="event-details-container">
        {event.is_streamed || (service?.videos && service?.videos?.length > 0) ? (
          <button
            onClick={(e) => {
              const videosContainer = ((e.target as HTMLButtonElement).getRootNode() as ShadowRoot).getElementById('videos-container');
              if (videosContainer) {
                const rect = videosContainer.getBoundingClientRect();
                window.scrollBy({
                  top: rect.top - window.innerHeight / 2, // replace 'x' with the number of pixels you want to offset
                  behavior: 'smooth',
                });
              }
            }}
          >
            <VideoCameraIcon className="event-icon" />
          </button>
        ) : (
          <LocationMarkerIcon className="event-icon" />
        )}
        <div>
          <strong>{event.name} </strong>
          {!event.is_venue_hidden && (
            <span>
              held at{' '}
              <a href={link} target="_blank" className="text-accent-color">
                {event?.venue.name}
              </a>
            </span>
          )}
        </div>
      </div>

      <div className="event-end-container">
        <div className="event-date">{!event.is_date_hidden && format(utcToZonedTime(new Date(event?.start_at), timezone), 'MMM d y - h:mm a')}</div>
        {event.is_date_hidden || !event.start_at ? null : <AddToCalender event={event} service={service} />}
      </div>
    </div>
  );
};

const ServiceEvents = ({
  events,
  service,
  timezone,
}: {
  events: FuneralServiceEvent[] | null | undefined;
  service: FuneralService;
  timezone: string;
}) => (
  <div className="events-container"> {events?.map((event) => <Event key={event.hash} event={event} service={service} timezone={timezone} />)}</div>
);

export default ServiceEvents;
